import { setCookie } from './cookiesManager';

const convertLocationToString = position => {
  const posData = {
    latitude: position.coords.latitude,
    longitude: position.coords.longitude,
  };

  return JSON.stringify(posData);
};

const getGeolocation = (handleSuccess, handleError) =>
  new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      position => {
        setCookie('userLocation', convertLocationToString(position), 20);
        handleSuccess(position);
        resolve(position);
      },
      error => {
        handleError(error);
        reject(error);
      }
    );
  });

const NATIVE_LOCATION_CALLBACK = '__onNativeLocationResult';

const getGeolocationNative = (handleSuccess, handleError) =>
  new Promise((resolve, reject) => {
    const androidBridge = typeof window !== 'undefined' && window.AndroidInterface?.getLocation;
    const iosBridge = typeof window !== 'undefined' && window.Capacitor?.Plugins?.NativeBridge?.getLocation;
    if (!androidBridge && !iosBridge) {
      return getGeolocation(handleSuccess, handleError);
    }
    window[NATIVE_LOCATION_CALLBACK] = jsonStr => {
      delete window[NATIVE_LOCATION_CALLBACK];
      try {
        const data = JSON.parse(jsonStr);
        if (data.error) {
          handleError(new Error(data.error));
          reject(new Error(data.error));
          return;
        }
        const position = {
          coords: {
            latitude: data.lat,
            longitude: data.lng,
            accuracy: null,
            altitude: null,
            altitudeAccuracy: null,
            heading: null,
            speed: null,
          },
          timestamp: Date.now(),
        };
        setCookie('userLocation', convertLocationToString(position), 20);
        handleSuccess(position);
        resolve(position);
      } catch (e) {
        handleError(e);
        reject(e);
      }
    };
    if (androidBridge) {
      window.AndroidInterface.getLocation(NATIVE_LOCATION_CALLBACK);
    } else {
      window.Capacitor.Plugins.NativeBridge.getLocation({ callbackName: NATIVE_LOCATION_CALLBACK });
    }
  });

export async function getGeolocationWithPermission(getAllStations, handleGeolocationError, handleGeolocationSuccess) {
  const useNative =
    typeof window !== 'undefined' &&
    (window.AndroidInterface?.getLocation || window.Capacitor?.Plugins?.NativeBridge?.getLocation);
  const getLoc = useNative ? getGeolocationNative : getGeolocation;
  try {
    if (navigator.permissions && navigator.permissions.query && !useNative) {
      const result = await navigator.permissions.query({ name: 'geolocation' });
      switch (result.state) {
        case 'granted':
          return await getLoc(handleGeolocationSuccess, handleGeolocationError);
        case 'prompt':
          return await getLoc(handleGeolocationSuccess, handleGeolocationError);

        case 'denied':
          handleGeolocationError('Permission denied');
          return getAllStations();

        default:
          throw new Error('Unknown permission state');
      }
    } else {
      return await getLoc(handleGeolocationSuccess, handleGeolocationError);
    }
  } catch (error) {
    console.error('Error in geolocation permission querying:', error);
    return getAllStations();
  }
}
